import React, { Component } from 'react'
import { connect } from 'react-redux'
import AssignDriverForm from './AssignDriverForm'
import { assignJob } from './jobs-reducer'
import KeyboardBackspaceIcon from 'material-ui-icons/KeyboardBackspace'
import { Link } from 'react-router-dom'
import Button from 'material-ui/Button'

class AssignDriverContainer extends Component {
  render () {
    const {
      job,
      successMsg,
      assignJob,
      isJobsRequestOngoing,
      drivers
    } = this.props

    const goBack = (<Link to='/jobs'>
      <Button color='primary'><KeyboardBackspaceIcon /> Go Back </Button>
    </Link>)

    if (!job) {
      return (<div>
        {goBack}
        <h4> No Job found</h4>
      </div>)
    }

    return <div>
      <h4> Assign driver to {job.job.title}</h4>
      {goBack}
      <AssignDriverForm
        title={job.title}
        driver={job.driver}
        onAssign={(driver) => assignJob(job.job._id, driver)}
        successMsg={successMsg}
        isJobsRequestOngoing={isJobsRequestOngoing}
        drivers={drivers}
      />
    </div>
  }
}

const mapStateToProps = ({jobs, users: {drivers}}, { match: { params } }) => ({
  isJobsRequestOngoing: jobs.isJobsRequestOngoing,
  successMsg: jobs.successMsg,
  drivers,
  job: jobs.jobs.find(job => job.job._id === decodeURIComponent(params.jobId))
})

const mapDispatchToProps = {
  assignJob
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignDriverContainer)



// WEBPACK FOOTER //
// ./src/jobs/AssignDriverContainer.js